import Svg, { Path } from "react-native-svg";
import { colors } from "./colors";

/** The sheet's back chevron. */
export function Chevron() {
  return (
    <Svg width={18} height={18} viewBox="0 0 24 24">
      <Path
        d="M15 18l-6-6 6-6"
        fill="none"
        stroke={colors.text}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Svg>
  );
}
